import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { t } from '@lingui/macro';
import { LockIcon, UnlockIcon } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';
import {
  StudentAccessWrapper,
  IconWrapper,
  Title,
  AccessSwitchWrapper
} from './styled';
import StudentAccessMenu from './student-access-menu';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import { restrictActivities } from '../../containers/course-assign/course-assign-actions';
import { useTracking } from '../../analytics';

const StudentAccess = ({ i18n }) => {
  const dispatch = useDispatch();
  const { trackAccessChanged } = useTracking();
  const studentAccessRef = useRef(null);

  const [showContextMenu, setContextMenu] = useState(false);
  const [positionXCallout, setPositionXCallout] = useState(0);
  const [positionYCallout, setPositionYCallout] = useState(0);

  const isRestricted = useSelector(
    (state) => state.CourseAssignReducer.assignments.isRestricted
  );

  const activeClass = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );

  const activeGroup = useSelector(
    (state) => state.CourseAssignReducer.activeGroup
  );

  const handleChangeRestriction = (switchState) => {
    if (activeClass && activeGroup !== '-1') {
      trackAccessChanged({ restricted: switchState });
      dispatch(restrictActivities(switchState, activeClass, activeGroup));
    }
  };

  const showContextModal = () => {
    const { bottom, x } = studentAccessRef.current.getBoundingClientRect();
    setPositionYCallout(bottom);
    setPositionXCallout(x);
    setContextMenu(!showContextMenu);
  };

  const icon = isRestricted ? (
    <SvgIcon icon={LockIcon} />
  ) : (
    <SvgIcon icon={UnlockIcon} />
  );

  const title = isRestricted
    ? i18n._(t('studentAccess.studentsOnTask')`Students on Task`)
    : i18n._(t('studentAccess.studentOpenAccess')`Student Open Access`);

  return (
    <OutsideClickHandler
      callback={() => setContextMenu(false)}
      forButton={`studentAccess`}
    >
      <StudentAccessWrapper ref={studentAccessRef}>
        <AccessSwitchWrapper
          isRestricted={isRestricted}
          data-testid="student-access"
          onClick={showContextModal}
        >
          <Title data-testid="student-access-title">{title}</Title>
          <IconWrapper>{icon}</IconWrapper>
        </AccessSwitchWrapper>
        <StudentAccessMenu
          isRestricted={isRestricted}
          showMenu={showContextMenu}
          positionX={positionXCallout}
          positionY={positionYCallout}
          i18n={i18n}
          handleChange={handleChangeRestriction}
          setContextMenu={setContextMenu}
        />
      </StudentAccessWrapper>
    </OutsideClickHandler>
  );
};

StudentAccess.propTypes = {
  i18n: PropTypes.object
};

export default StudentAccess;



// WEBPACK FOOTER //
// ./components/student-access/student-access.js